import { Checkbox } from '@pms-digital/design-system';

interface ExportToggleFieldProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Small explanatory line under the checkbox, e.g. why it is disabled. */
  hint?: string | null;
}

/** A labelled checkbox of the export panel, the design system's `Checkbox`. */
export function ExportToggleField({
  label,
  checked,
  onChange,
  disabled = false,
  hint = null,
}: ExportToggleFieldProps) {
  return (
    <Checkbox
      label={label}
      checked={checked}
      disabled={disabled}
      description={hint ?? undefined}
      onCheckedChange={onChange}
    />
  );
}
